"use client";
import { FunctionComponent, ReactNode, useEffect, useState } from "react";

export interface DelayedViewProps {
  children: ReactNode;
  delay?: number;
}

/**
 * delay showing a loader a min duration.
 * Prevents flicker for api calls that resolve quickly
 */
export const DelayedView: FunctionComponent<DelayedViewProps> = ({
  children,
  delay = 1000,
}) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, delay);
    return () => {
      clearTimeout(timer);
    };
  }, [delay]);
  return <>{show && children}</>;
};
